import { createSlice } from "@reduxjs/toolkit";
export const namespace = "order";

const initialState = {
  loading: true,
  error: null,
  data: null,
};

export const slice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    getOrderReducer: (state) => ({
      ...state,
      // loading: true,
    }),
    resetOrder: () => ({
      ...initialState,
    }),
    getSuccess: (state, action) => ({
      ...state,
      error: null,
      data: action.payload,
      loading: false,
    }),
    getError: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
      data: null,
    }),
    getFee: (state) => ({
      ...state
    }),
    createOrder: (state) => ({
      ...state
    }),
    updateOrder: (state) => ({
      ...state
    }),
  }
});

// Action creators are generated for each case reducer function
export const { get, getSuccess, getError, getFee, createOrder, updateOrder, getOrderReducer, resetOrder } = slice.actions;
// Selector
export const orderSelector = (state) => state[namespace];
// Reducer
export const { reducer } = slice;

export { rootSagas as saga } from "./saga";
